export default {
  menu: {
    home: '首页',
    product: '产品',
    about: '关于我们',
    login: '登入',
    register: '注册'
  },
  action: {
    switchLanguage: '语言切换成功'
  }
}
